/* sm-bottom-nav — mevcut cekmeceleri tetikler, yenisini yazmaz.
   Olculen tetikleyiciler (390x844, canli DOM):
     Shop   -> summary.header__icon--menu .click()  (details.open=true YETMIYOR)
     Search -> search-button button
     Cart   -> cart-drawer-component button[aria-label="Cart"]
   Olculen sepet olayi: 'cart:update' (product-form-component uzerinde). */
const MQ = window.matchMedia('(max-width: 749px)');
const nav = document.querySelector('.sm-bnav');
let started = false;

const open = (kind) => {
  if (kind === 'shop') {
    // OLCULDU: details.open=true ceker ama cekmece left:-370 / visibility:hidden kalir.
    // Temanin kendi summary tiklamasi gerekli; ancak o zaman left:0 / visible oluyor.
    const sum = document.querySelector('summary.header__icon--menu');
    if (sum) { sum.click(); return true; }
  }
  if (kind === 'search') {
    const b = document.querySelector('search-button button');
    if (b) { b.click(); return true; }
  }
  if (kind === 'cart') {
    const b = document.querySelector('cart-drawer-component button[aria-label="Cart"]');
    if (b) { b.click(); return true; }
  }
  return false; // tetikleyici yok -> href'e birak
};

const badge = (n) => {
  const b = nav && nav.querySelector('.sm-bnav__b');
  const link = nav && nav.querySelector('[data-sm-nav="cart"]');
  if (!b || !link) return;
  if (n > 0) { b.hidden = false; b.textContent = n > 99 ? '99+' : String(n); }
  else b.hidden = true;
  link.setAttribute('aria-label', n === 1 ? 'Cart, 1 item' : 'Cart, ' + n + ' items');
};

const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } })
  .then((r) => r.json()).then((j) => badge(j.item_count)).catch(() => {});

const start = () => {
  if (started || !nav) return;
  started = true;
  nav.addEventListener('click', (e) => {
    const a = e.target.closest('[data-sm-nav]');
    if (!a) return;
    const kind = a.dataset.smNav;
    if (open(kind)) e.preventDefault();
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', 'bottom_nav_click', { tab: kind }); } catch (_) {}
    }
  });
  // Olculen olay; yakalama fazinda dinlenir ki bubbles:false olsa da yakalansin.
  document.addEventListener('cart:update', refresh, true);
};

const sync = () => { if (MQ.matches) { start(); document.body.classList.add('sm-bnav-on'); }
                     else document.body.classList.remove('sm-bnav-on'); };
MQ.addEventListener('change', sync);
sync();

/* --- Cekmeceyi kapatmanin KOLAY yollari (25 Eki) ---
   Olculdu: tema yalnizca X ile kapaniyor; backdrop dokunusu ve Escape calismiyor.
   Cekmece ekranin %95'ini kapladigi icin kullanici cikis bulamiyor. */
const drawer = () => document.querySelector('details.menu-drawer-container[open]');
const kapat = () => { const d = drawer(); if (d) { d.open = false; return true; } return false; };

// 1) Cekmecenin DISINA dokunma kapatir (20px'lik serit + backdrop)
document.addEventListener('click', (e) => {
  if (!drawer()) return;
  if (e.target.closest('.menu-drawer')) return;      // ic tiklamalar gecer
  if (e.target.closest('summary.header__icon--menu')) return; // acan dugme
  if (kapat()) { e.preventDefault(); e.stopPropagation(); }
}, true);

// 2) Escape kapatir (klavyeli cihazlar)
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') kapat(); });

// 3) Sola kaydirma kapatir — soldan acilan cekmece icin dogal hareket
let sx = 0, sy = 0, izle = false;
document.addEventListener('touchstart', (e) => {
  if (!drawer() || !e.touches[0]) return;
  sx = e.touches[0].clientX; sy = e.touches[0].clientY; izle = true;
}, { passive: true });
document.addEventListener('touchend', (e) => {
  if (!izle || !e.changedTouches[0]) return;
  izle = false;
  const t = e.changedTouches[0];
  const dx = t.clientX - sx;
  const dy = Math.abs(t.clientY - sy);
  if (dx < -55 && dy < 45) { kapat(); return; }        // sola kaydirma
  // Olculdu: cekmece acikken backdrop'a dokunma CLICK uretmiyor (preventDefault).
  // Bu yuzden dokunusu touchend'den yakaliyoruz: kucuk hareket = tap.
  if (Math.abs(dx) < 12 && dy < 12) {
    const hedef = document.elementFromPoint(t.clientX, t.clientY);
    if (hedef && !hedef.closest('.menu-drawer') && !hedef.closest('summary.header__icon--menu')) kapat();
  }
}, { passive: true });
